import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=5b5e9d92&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"
import style0 from "./Home.vue?vue&type=style&index=0&id=5b5e9d92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../Vue/course_selecttion_v3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5e9d92",
  null
  
)

export default component.exports